<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
            fixed-header
            height="calc(100vh - 300px)"
          >
            <template v-slot:item="{ item }">
              <tr :active="item.selected" @click="item.selected = !item.selected" class="list-clickable">
                <td>{{ item.ID }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.FullName}}</td>
                <td class="text-right">{{ item.Wallet | currency}}</td>
                <td class="text-right">{{ item.TotalAmount | currency}}</td>
                <td class="text-right">{{ item.TotalDebt | currency}}</td>
                <td>{{ item.PhoneNumber }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, customer_status)}">{{ item.Status | display_value(customer_status) }}</td>
                <!-- <td class="text-right" v-if="roleAdmin">
                    <v-edit-dialog :return-value.sync="item.ShipmentWeightPrice" large lazy @save="saveItem({'ID': item.ID, 'ShipmentWeightPrice': item.ShipmentWeightPrice})">
                        <div>{{ item.ShipmentWeightPrice | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.ShipmentWeightPrice" type="number" step="1" label="Phí cân lô" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.ShipmentWeightPrice | currency }}</td>
                <td class="text-right" v-if="roleAdmin">
                    <v-edit-dialog :return-value.sync="item.ShipmentVolumePrice" large lazy @save="saveItem({'ID': item.ID, 'ShipmentVolumePrice': item.ShipmentVolumePrice})">
                        <div>{{ item.ShipmentVolumePrice | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.ShipmentVolumePrice" type="number" step="1" label="Phí khối lô" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.ShipmentVolumePrice | currency }}</td> -->
                <td v-if="roleAdmin">
                  <v-edit-dialog :return-value.sync="item.SaleID" large lazy @save="saveItem({'ID': item.ID, 'SaleID': item.SaleID})">
                        <div>{{ getStaffName(item.SaleID) }}</div>
                        <template v-slot:input>
                          <v-select v-model="item.SaleID" :items="sales" item-value="ID" item-text="FullName" label="Nhân viên sale" single-line autofocus></v-select>
                        </template>
                    </v-edit-dialog>
                </td>
                <td v-else>{{ getStaffName(item.SaleID) }}</td>
                <td class="text-center">
                  <v-icon class="mr-2" v-if="roleEditable" medium @click="deleteItem(item.ID)">delete</v-icon>
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon medium class="mr-2" color="red" @click="resetPassword(item.ID)" v-on="on">autorenew</v-icon>
                      </template>
                      <span>Reset mật khẩu về mặc định</span>
                  </v-tooltip>  
                  <a 
                  target="_blank" 
                  :href="'/khach-hang/' + item.ID"
                  ><i role="button" medium="" class="v-icon notranslate mr-2 v-icon--link material-icons theme--light">{{roleEditable ? 'edit' : 'visibility'}}</i></a>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <span>
                <p class="pt-2">Không có dữ liệu</p>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import md5 from "md5";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      search: "",
      headers: [
        {
          text: this.$t('table_headers.id'),
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: this.$t('table_headers.customer_code'),
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: this.$t('table_headers.full_name'),
          value: "FullName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: this.$t('table_headers.wallet'),
          value: "Wallet",
          filterable: true,
          align: 'end',
          dataType: dataType["Number"]
        },
        {
          text: this.$t('table_headers.order_amount'),
          value: "TotalAmount",
          filterable: true,
          align: 'end',
          dataType: dataType["Number"]
        },
        {
          text: this.$t('table_headers.debt'),
          value: "TotalDebt",
          filterable: true,
          align: 'end',
          dataType: dataType["Number"]
        },
        {
          text: this.$t('table_headers.phone'),
          value: "PhoneNumber",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: this.$t('table_headers.status'),
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.CUSTOMER_STATUS_LIST
        },
        // {
        //   text: this.$t('table_headers.weight_fee'),
        //   value: "ShipmentWeightPrice",
        //   align: 'end',
        //   filterable: true,
        //   decimal: 0,
        //   dataType: dataType["Number"]
        // },
        // {
        //   text: this.$t('table_headers.volume_fee'),
        //   value: "ShipmentVolumePrice",
        //   align: 'end',
        //   filterable: true,
        //   decimal: 0,
        //   dataType: dataType["Number"]
        // },
        {
          text: this.$t('table_headers.sale_staff'),
          value: "SaleID",
          filterable: true,
          values: [],          
          dataType: dataType["Enum"]
        },
        {
          text: this.$t('table_headers.action'),
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      customer_status: configs.CUSTOMER_STATUS_LIST,
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      viewName: "customer_list",
      filterConditions: [],
      quickFilterConditions: []
    };
  },
  computed: {
    ...mapState({
      items: state => state.customer.all.data,
      total_rows: state => state.customer.all.total,
      loading: state => state.customer.loading,
      selected: state => state.customer.selected,
      sales: state => state.staff.all.data,
    }),
    roleAdmin() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    },
    rolePayment() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Payment;
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Sale || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
    }
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("customer/getCustomerList", param);
      this.$store.dispatch("staff/getList");
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "CustomerDetail",
        params: {
          Pid: id,
          title: `Khách hàng (#${id})`
        }
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", {'id': id, 'viewName': this.viewName});
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      if(this.roleEditable) {
        this.selected = {
            ID: 0,
            RoleID: 0,
            Status: 1,
            is_active: 1,
            is_admin: 0
        };
        this.$router.push({
          name: "CustomerDetail",
          params: {
            Pid: 'tao-moi',
            title: `Tạo mới khách hàng`
          }
        });
      }
      else {
        sendErrorNotice("Bạn không có quyền tạo mới khách hàng!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("customer/setCustomerDetail", {
        'data': item,
        'id': item.ID
      });
    },
    getStaffName(id) {
      const staff = _.find(this.sales, { ID: id });
      return staff ? staff.FullName : "";
    },
    resetPassword: function(id) {
      this.$store.dispatch("customer/setCustomerDetail", {
          'data': {Password: md5('123@456')},
          'id': id,
          'resetPwd': true
      });
    },
    exportData() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("customer/exportList", param);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
      if(item.viewName == this.viewName) {
        this.$store.dispatch("customer/removeCustomerDetail", item.id);
      }
    });
  },
  beforeMount() {
    this.$store.commit("customer/setCustomerList", {data: []})
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_EXPORT_ACTION");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style scoped>
a {
    text-decoration: none !important;
}
</style>